import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
interface SlideSnakJourneyProps {
  onContinue: () => void;
}
export function SlideSnakJourney({
  onContinue
}: SlideSnakJourneyProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 150);
    const t2 = setTimeout(() => setStage(2), 600);
    return () => {
      ;
      [t1, t2].forEach(clearTimeout);
    };
  }, []);
  return <div className="h-full w-full flex items-stretch justify-center px-4 py-4 md:px-6 md:py-6" data-id="element-759">
      <div className="w-full max-w-[1400px] bg-white rounded-2xl shadow-2xl flex flex-col p-5 md:p-8 overflow-hidden" data-id="element-760">
        {/* Top eyebrow + legend chip */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        y: stage >= 1 ? 0 : 10
      }} className="flex items-center justify-between gap-4 mb-3" data-id="element-761">
          <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-762">
            Real campaigns · Real HCP engagement
          </p>
          <div className="flex items-center gap-2 bg-[#F5F0FF] border border-[#E4D7FF] rounded-full px-3 py-1.5" data-id="element-763">
            <div className="w-5 h-5 rounded-full bg-[#6C2BD9] text-white flex items-center justify-center" data-id="element-764">
              <BarChart3 className="w-3 h-3" data-id="element-765" />
            </div>
            <span className="text-[11px] font-semibold text-[#6C2BD9]" data-id="element-766">
              = behavioral data captured
            </span>
          </div>
        </motion.div>

        {/* The actual moodboard image — full bleed */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        scale: stage >= 1 ? 1 : 0.98
      }} transition={{
        duration: 0.5
      }} className="flex-1 min-h-0 rounded-xl border border-slate-200 overflow-hidden bg-white flex items-center justify-center" data-id="element-767">
          <img src="https://cdn.magicpatterns.com/uploads/uHtN7YcsUwvpLFaZ6DypnY/Screenshot_2026-05-28_at_11.57.19.png" alt="Snaks throughout the customer journey" className="w-full h-full object-contain" data-id="element-768" />
        </motion.div>

        {/* Footer takeaway */}
        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: stage >= 2 ? 1 : 0,
        y: stage >= 2 ? 0 : 8
      }} className="mt-3 rounded-xl bg-[#F5F0FF] border border-[#E4D7FF] px-4 py-3 flex items-center gap-3" data-id="element-769">
          <div className="w-8 h-8 rounded-lg bg-[#6C2BD9] text-white flex items-center justify-center flex-shrink-0" data-id="element-770">
            <Sparkles className="w-4 h-4" data-id="element-771" />
          </div>
          <p className="text-xs md:text-sm text-slate-800 leading-relaxed" data-id="element-772">
            <span className="font-bold" data-id="element-773">
              One Snak format. Every stage of the journey.
            </span>{' '}
            Centrally created, locally deployed, continuously optimized — with
            behavioral data fueling the next campaign.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: stage >= 2 ? 1 : 0
      }} className="mt-3 flex justify-end" data-id="element-774">
          <Button onClick={onContinue} data-id="element-775">Platform Architecture</Button>
        </motion.div>
      </div>
    </div>;
}